import { Record } from '@common/data-models/records/record';
import { SingleFeedViewStateRecord } from '@common/data-models/records/single-feed-viewstate-record';
import { ViewStateTypes } from "@common/enums/viewstate-types";
import { ViewStateOptions } from "@common/data-models/navigation/viewstate-options";
import { PSTFieldNames } from "@common/data-models/fields/pst-field-names";
import { ViewStateOptionsSerializer } from "@common/data-models/serializers/serializers";


export class RSSFeedViewStateRecord extends SingleFeedViewStateRecord {
    
    public initialize() {
        super.initialize();
        this.viewStateType = ViewStateTypes.RSSFEED;
        this.viewStateLayout = ViewStateOptionsSerializer.Instance(Record.globalTablesService).initialize(this.viewStateType, PSTFieldNames.PSTViewStateLayout);
    }

    public get viewStateLayout(): ViewStateOptions { return this.getAs<ViewStateOptions>("PSTViewStateLayout"); }
    public set viewStateLayout(value: ViewStateOptions) { this.set("PSTViewStateLayout", value); }

    public get viewStateFeedURL(): string { return this.getAs<string>(PSTFieldNames.PSTViewStateFeedURL); }
    public set viewStateFeedURL(value: string) { this.set(PSTFieldNames.PSTViewStateFeedURL, value); }
}
